import { makeStyles } from '@mui/styles';

const style = makeStyles((theme: any) => ({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '264px',
  },
  captionText: {
    position: 'absolute',
    bottom: '5px',
  },
  bgImage: {
    position: 'absolute',
    width: '100%',
    top: '0',
    right: '0',
    left: '0',
    zIndex: -2,
  },
  overlap: {
    position: 'absolute',
    left: 0,
    right: 0,
    background: '#000000a8',
    bottom: 0,
    zIndex: -1,
    top: 0,
    width: '100%',
    height: '100%',
  },
  [theme.breakpoints.up('sm')]: {
    mainContainer: {
      minHeight: '380px',
    },
  },
  [theme.breakpoints.up('md')]: {
    captionText: {
      bottom: 19,
      right: 120,
    },
  },
}));
export default style;
